import React, { createContext, useContext, useState } from 'react';

const ERACustomizerContext = createContext();

export const useERACustomizer = () => useContext(ERACustomizerContext);



export const ERACustomizerProvider = ({ children }) => {
  const [activeDir, setDir] = useState('ltr');
  const [activeMode, setDarkMode] = useState('light');
  const [activeTheme, setTheme] = useState('NANG');
  const [SidebarWidth, setSidebarWidth] = useState(270);
  const [MiniSidebarWidth, setMiniSidebarWidth] = useState(75);
  const [TopbarHeight, setTopbarHeight] = useState(80);
  const [isLayout, setIsLayout] = useState('full');
  const [isCollapse, setIsCollapse] = useState(false);
  const [isSidebarHover, setIsSidebarHover] = useState(false);
  const [isMobileSidebar, setIsMobileSidebar] = useState(false);
  const [isHorizontal, setIsHorizontal] = useState(false);
  const [language, setLanguage] = useState('en');
  const [isCardShadow, setCardShadow] = useState(true);
  const [borderRadius, setBorderRadius] = useState(8);
  const [expandedMenus, setExpandedMenus] = useState({})

  const toggleMenuExpansion = (id) => {
    setExpandedMenus({ ...expandedMenus, [id]: !expandedMenus[id] });
  }
  const toggleSidebar = () => setIsCollapse(!isCollapse);
  const hoverSidebar = (hover) => setIsSidebarHover(hover);
  const toggleMobileSidebar = () => setIsMobileSidebar(!isMobileSidebar);
  const toggleLayout = (layout) => setIsLayout(layout);
  const toggleHorizontal = (horizontal) => setIsHorizontal(horizontal);

  return (
    <ERACustomizerContext.Provider value={{
      activeDir, setDir,
      activeMode, setDarkMode,
      activeTheme, setTheme,
      SidebarWidth, setSidebarWidth,
      MiniSidebarWidth, setMiniSidebarWidth,
      TopbarHeight, setTopbarHeight,
      isLayout, toggleLayout,
      isCollapse, toggleSidebar,
      isSidebarHover, hoverSidebar,
      isMobileSidebar, toggleMobileSidebar,
      isHorizontal, toggleHorizontal,
      language, setLanguage,
      isCardShadow, setCardShadow,
      borderRadius, setBorderRadius,
      expandedMenus, toggleMenuExpansion
    }}>
      {children}
    </ERACustomizerContext.Provider>
  );
};